import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

export interface TripAddressRow {
  value: string;
  isPrimary?: boolean;
}

@Component({
  selector: 'app-trip-address',
  templateUrl: './trip-address.component.html',
  styleUrls: ['./trip-address.component.scss']
})
export class TripAddressComponent implements OnInit, OnChanges {

  @Input()
  iconUrl: string;

  iconUrlSanitized;

  constructor(
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.iconUrl) {
      this.iconUrlSanitized = this.sanitizer.bypassSecurityTrustUrl(this.iconUrl);
    }
  }

}
